import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type { ImageProps } from '@wix/thunderbolt-components-native';

import type {
  FlashComponentDefinition,
  FlashComponentProps,
} from '../FlashComponent.types';

const props = withCompInfo<FlashComponentProps, FlashComponentDefinition>()(
  ['compData', 'compProps', 'topology'],
  ({ compData, compProps, topology }) => {
    const { uri, placeHolderImage } = compData;
    const placeholderImage: Partial<ImageProps> = { ...placeHolderImage };
    placeholderImage.displayMode =
      compProps.displayMode === 'stretch' ? 'fill' : 'fit';

    return {
      uri: uri ? `${topology.mediaRootUrl}media/${uri}` : undefined,
      placeholderImage,
      // TODO: Change when correct type is added to TB
      link: (compData.link || null) as FlashComponentProps['link'],
    };
  },
);

export default createComponentMapperModel({ props });
